import React from 'react';
import PropTypes from 'prop-types';

import { TextField } from 'material-ui';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';

import { ReduxFormField, ReduxFormFieldCheckPopup } from 'components';

import classNames from 'classnames/bind';
import styles from './ReduxFormCommon.css';
const cx = classNames.bind(styles);

const renderField = ({
  input,
  meta,
  checkType,
  className,
  validate,
  warn,
  refPass,
  error,
  onChangeExtraEvent,
  ...rest
}) => {
  return (
    <div>
      <TagsInput
        {...input}
        onChange={input.onChange}
        value={Array.isArray(input.value) ? input.value : []}
        className={cx(className)}
        ref={refPass}
        renderInput={props => {
          const { onChange, value, addTag, ...other } = props;
          return (
            <TextField
              fullWidth
              error={error || false}
              onChange={onChange}
              value={value}
              {...other}
              // 이렇게 onFocus, onBlur을 other 뒤에 두어 redux-form input 핸들러로 대체
              onFocus={e => input.onFocus()}
              onBlur={e => input.onBlur()}
              className={cx(
                rest.inputProps && rest.inputProps.className ? rest.inputProps.className : '',
                error ? 'validate-error' : ''
              )}
            />
          );
        }}
        {...rest}
      />
      <ReduxFormFieldCheckPopup checkType={checkType} {...meta} />
    </div>
  );
};

const ReduxFormTagsInput = ({ ...rest }) => {
  return <ReduxFormField component={renderField} {...rest} />;
};

ReduxFormTagsInput.propTypes = {
  checkType: PropTypes.number
};
ReduxFormTagsInput.defaultProps = {
  checkType: 99
};

export default ReduxFormTagsInput;



// WEBPACK FOOTER //
// ./src/script/components/reduxForm/ReduxFormTagsInput.js